import { getDiscount, getItemCategory, getItemCategory2, normalizeBrand } from '../../utils';

export async function itemsFromList(context: Record<string, any>) {
  return (context?.list || []).map((item: any) => {
    return {
      price: item?.price?.list || item?.price || item?.offers?.lowPrice || item?.priceRange?.listPrice?.highPrice || null,
      quantity: 1,
      item_ref: item?.ref || item?.item_ref || item?.referenceId?.[0].Value || item?.productReference || item?.additionalProperty.find((i: { name: string }) => i.name === "RefId").value || null,
      index: typeof context?.index === 'number' ? context.index : Number(item?.index),
      item_brand: item.isNotFarm ? item?.item_brand : normalizeBrand(item?.brand?.name) || normalizeBrand(context.brand) || normalizeBrand(item?.item_brand) || null,
      item_name: item?.productName?.split(' - ').shift() || item?.alternateName?.split(' - ').shift() || item?.item_name?.split(' - ').shift() || item?.seo?.title?.split(' - ').shift() || null,
      item_category: getItemCategory(item) || null,
      item_variant: item?.name?.split("-")?.[0].trim() || item?.item_variant || item?.productName?.split("-")?.[1].trim() || null,
      item_category2: getItemCategory2(item) || null,
      item_id: item?.productID || item?.productId || item?.item_id || item?.id || null,
      discount: getDiscount(item) || null,
      item_list_name: context?.itemListName || getItemCategory(item) || null,
    }
  })
}
